"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var messages = {
  cs: {
    com: {
      components: {
        headerCartButton: {
          cartButton: 'Košík'
        }
      },
      productDetail: {
        parameters: {
          title: 'Parametry'
        }
      },
      productAvailability: {
        format: {
          available: 'Skladem',
          moreThanX: 'Více než {min} kusů skladem',
          exactCount: '{value} kusů skladem',
          notAvailable: 'Nedostupné'
        }
      },
      imageGallery: {
        thumbnailsMore: '+ {number} více'
      },
      relatedProducts: {
        title: 'Související produkty'
      },
      productAccessories: {
        title: 'Příslušenství'
      },
      productDetailImageGallery: {
        noImage: 'Bez obrázku'
      },
      productAvailabilityFieldPreviewWithPopup: {
        button: 'Kdy dostanu zboží?'
      }
    }
  }
};
var _default = messages;
exports.default = _default;